import React from "react";
import { useSearchParams } from "react-router-dom";

import PageWrapper from "../../../../components/layout/page/PageWrapper";

import GlobalSearchField from "../views/GlobalSearchField";
import GlobalSearchView from "../views/GlobalSearchView";

import "./GlobalSearchPage.css";

export default function GlobalSearchPage() {
  const [searchParams] = useSearchParams();

  const search = searchParams.get("q") || "";
  const type = searchParams.get("type") || "videos";

  return (
    <PageWrapper>
      <div className="global-search-page">

        <div className="global-search-page__field">
          <GlobalSearchField />
        </div>

        <div className="global-search-page__results">
          <GlobalSearchView search={search} type={type} />
        </div>
      </div>
    </PageWrapper>
  );
}
